<template>
    <el-container>
        <tab-user></tab-user>
    </el-container>
</template>

<script>
    import TabUser from './tab_user.vue'
    import TabRole from './tab_role.vue'
  export default {
    name: "User",
    data() {
      return {
      }
    },
    components:{
      TabUser,TabRole
    },
    methods: {
    }
  }
</script>
<style scoped>
    .app-container2 {
       margin:10px 20px 20px 20px;
   }
</style>
